import { useParams } from "react-router-dom";
import React from "react";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import plusicon from '../../../assets/img/product_img/plusicon.png';
import { Link } from "react-router-dom";
import Breadcrumb from "../../../Breadcrumb";
import { Helmet } from "react-helmet-async";
import bannerIMG from "../../../../src/assets/bannerImages/main-img.jpg";
import childImg1 from "../../../assets/img/child-img/indoor playground square fit 1.png";
import childImg2 from "../../../assets/img/child-img/indoor playground square fit 2.png";
import childImg3 from "../../../assets/img/child-img/indoor playground square fit 3.png";
import childImg4 from "../../../assets/img/child-img/indoor playground square fit 4.png";
import WhatsappButton from "../../../components/WhatsappButton";
const ProductsNinja = () => {
  let content;
  const { type } = useParams();
  console.log(type);

  if (type === "NinjaKids") {
    content = (
      <div className="p-container">
         <div className="p-img-box" style={{ position: "relative", display: "inline-block" }}>
  <div
    className="breadcrumb-overlay"
    style={{
      position: "absolute",
      top:'100%',
      left: "20%",
      transform: "translate(-50%, 3%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    }}
  >
<Breadcrumb textColor="#000" />
</div>
<img src={bannerIMG} alt="highest quality trampoline" className="main-img"></img>
</div>
        <h1 className="p-heading">Ninja Kids</h1>
        <div className="p-heading-p-heading">
      <div className="p-heading-p-text">
        <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
          Ninja Kids is a variety of ninja-style obstacle courses designed to challenge and engage young warriors. From climbing walls to swinging ropes, balance beams, and agility challenges, this interactive game helps children develop strength, coordination, and confidence while having endless fun.
        </h2>
      </div>
      </div>
        <div className="p-content-box">
          <div className="p-mini-content-1">
            <h3 className="p-sub-heading-2">Why Choose Ninja Kids?</h3>
            <ul typeof="text-box">
             
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Premium Quality Materials</b>  – Built to last with durable, high-strength components.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Safety First</b> – Soft padding, anti-slip surfaces, and secure harness systems ensure a safe play experience.
                </h2>
              </li>
              <li className="p-text-2">

                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Engaging Design</b> – Colorful and exciting themes to captivate kids’ imaginations.

                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Customizable Options</b> – Tailor-made designs to fit any indoor playground layout.
                </h2>
              </li>
              
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  Transform your indoor playground into an adventure-filled ninja training ground with Ninja Kids. Let the little warriors climb, jump, swing, and conquer.
                </h2>
              </li>
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="highest quality trampoline" />
              <img src={childImg3} alt="indoor playground with slide" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="indoor commercial playground" />
              <img src={childImg4} alt="playground equipment manufacturers" />
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (type === "NinjaCourse") {
    content = (
      <div className="p-container">
        <div className="p-img-box" style={{ position: "relative", display: "inline-block" }}>
  <div
    className="breadcrumb-overlay"
    style={{
      position: "absolute",
      top:'105%',
      left: "20%",
      transform: "translate(-50%, 3%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    }}
  >
<Breadcrumb textColor="#000" />
</div>
<img src={bannerIMG} alt="playTurn on screen reader supportground equipment catalog
" className="main-img"></img>
</div>
        <h1 className="p-heading">Ninja Course</h1>
        <div className="p-heading-p-heading">
      <div className="p-heading-p-text">
        <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
          At Global Entertainment Manufacturer, we bring adventure and excitement to indoor playgrounds with our Ninja Course—a dynamic and challenging obstacle course designed for thrill-seekers of all ages. Crafted with premium-quality materials and built to the highest safety standards, our Ninja Course transforms any indoor playground into a high-energy action zone.
        </h2>
      </div>
      </div>


 
        <div className="p-content-box">
          <div className="p-mini-content-1">

            <h3 className="p-sub-heading-2">What is Ninja Course?</h3>
            <ul typeof="text-box">

              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                The Ninja Course is an interactive play area featuring a series of obstacle challenges, including climbing walls, rope swings, balance beams, monkey bars, and more.
              </h2>
              </li>
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Designed to test agility, strength, and coordination, this exhilarating attraction keeps players engaged while enhancing their physical and mental endurance.
              </h2>
              </li>
          
              <h3 className="p-sub-heading-2">
              Why Choose Our Ninja Course?
          </h3>
             
              <li className="p-text-2">
              <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                <b>Premium Quality Materials</b> – Durable, high-strength components for long-lasting performance.
              </h2>
                
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Safety First</b> – Soft padding, non-slip surfaces, and secure structures ensure a safe play experience.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Customizable Designs</b> – Tailor-made layouts to fit any indoor playground space.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Exciting & Engaging</b> – A fun way for kids and adults to stay active and challenge themselves.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                  <b>Turn your indoor playground into an action</b> – packed ninja training ground with Global Entertainment Manufacturer’s Ninja Course. Let players climb, swing, and conquer every obstacle for an unforgettable adventure.
                </h2>
              </li>
              <li className="p-text-2">
                <h2 style={{color: '#000000',fontWeight: 400,fontSize: '16px',lineHeight: '26px',letterSpacing: '2%',}}>
                Introducing our enhanced Playground Management Software, meticulously crafted to optimize the operations of indoor playgrounds and trampoline parks.Our comprehensive suite of integrated solutions ensures a seamless experience for both operators and guests, emphasizing efficiency, security, and enjoyment.
                </h2> 
               </li>
               
            </ul>
          </div>

          <div className="p-mini-content-2">
            <div className="p-img-right-box">
              <img src={childImg1} alt="playground equipment suppliers" />
              <img src={childImg3} alt="commercial indoor playground equipment" />{" "}
            </div>
            <div className="p-img-left-box">
              <img src={childImg2} alt="playgrounds" />
              <img src={childImg4} alt="indoor commercial playground" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Helmet>
                    <meta name="indoor playground" content="Experience the ultimate fun with GEM, the highest quality trampoline
 for your indoor playground. Perfect for endless entertainment and 
active play indoors" />

      <meta name="playground equipment manufacturers" content="GEM offers the highest quality trampoline, perfect for kids 
playgrounds. Safe, durable, and fun for all ages, providing 
endless hours of outdoor enjoyment!" />
      
                  </Helmet>
        <Header />
        <div >
            <WhatsappButton
              altText="Chat with us on WhatsApp"
              iconSize={70}
            />
            <Link to="/getquotations" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="icon-container">
                <img
                  src={plusicon}
                  alt="highest quality trampoline"
                  className="Producticon"
                  style={{ cursor: "pointer" }}
                />
                <button className="quotation-button">Get Quotation</button>
              </div>
            </Link>
          </div>
        {content}
        <Footer />
    </div>
  );
};
export default ProductsNinja;
